import React, { useContext } from "react";
import classes from './BoardsAll.module.scss';
import { BoardContext } from "../../store/board-context";
import { ModalContext } from "../../store/modal-context";
import { AuthContext } from "../../store/auth-context";
import Board from "../Board/Board";
import IconBoard from "../Icons/IconBoard";

const BoardsAll = () => {
    const { boards, activeBoardIndex, isLoading, error } = useContext(BoardContext);
    const { openModal } = useContext(ModalContext);
    const { user } = useContext(AuthContext);

    if (isLoading) {
        return (
            <section className={classes.boardsAll}>
                <p style={{ padding: "2rem" }}>Loading boards…</p>
            </section>
        );
    }

    if (error) {
        return (
            <section className={classes.boardsAll}>
                <p style={{ padding: "2rem" }}>
                    Couldn't reach the server: {error}. Retrying will happen automatically on your next action.
                </p>
            </section>
        );
    }

    if (boards.length === 0) {
        const name = user?.email ? user.email.split("@")[0] : null;
        return (
            <section className={classes.boardsAll}>
                <div className={classes.emptyState}>
                    <div className={classes.emptyCard}>
                        <span className={classes.emptyIcon}>
                            <IconBoard fill="var(--color-secondary)" />
                        </span>
                        <h2 className={classes.emptyHeading}>
                            {name ? `Welcome, ${name}!` : "Welcome!"}
                        </h2>
                        <p className={classes.emptySubtext}>
                            You don't have any boards yet. Create your first one to start organizing your tasks.
                        </p>
                        <button
                            type="button"
                            className={classes.emptyCta}
                            onClick={() => openModal("addBoard")}
                        >
                            + Create New Board
                        </button>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={classes.boardsAll}>
            {boards.map((board, index) => (
                <div
                    key={board.id}
                    className={classes.boardWrapper}
                    style={{
                        transform: `translateY(${(index - activeBoardIndex) * 100}%)`,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                    }}
                >
                    <Board boardId={board.id} />
                </div>
            ))}
        </section>
    );
};

export default BoardsAll;
